export default [
  {
    key: 'Unique_Market_Reference_UMR',
    label: 'UMR',
    searchable: false,
    sortable: true,
  },
  { key: 'Risk_Code', label: 'Risk Code', searchable: false, sortable: true },
  { key: 'Lloyds_Cat_Code', label: 'Cat Code', searchable: false, sortable: true },
  { key: 'TPA_Name', label: 'TPA Name', searchable: false, sortable: true },
  {
    key: 'Claim_Reference',
    label: 'Claim Reference',
    searchable: false,
    sortable: true,
    width: '250px',
  },
  {
    key: 'Insured_Full_Name',
    label: 'Insured Name',
    searchable: false,
    sortable: true,
    width: '300px',
  },
  {
    key: 'Reporting_Period_End_Date',
    label: 'Report Date',
    searchable: false,
    sortable: true,
    isDate: true,
  },
];
